var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "External",

    getDefaultProps () {
        return {"width":"11px","height":"12px","viewBox":"0 0 11 12","version":"1.1","xmlns":"http://www.w3.org/2000/svg","data-svgreactloader":"[[\"http://www.w3.org/2000/svg\",\"xlink\",\"http://www.w3.org/1999/xlink\"]]"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <title>CC7D435A-75F0-4CBE-A19A-7724AD671715</title>
  <desc>Created with sketchtool.</desc>
  <defs/>
  <g id="Page-1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
    <g id="More-Details" transform="translate(-697.000000, -270.000000)" stroke="currentColor">
      <g id="icon" transform="translate(698.000000, 270.000000)">
        <polyline id="Rectangle-2" strokeLinecap="round" strokeLinejoin="round" transform="translate(5.871122, 4.267082) rotate(-45.000000) translate(-5.871122, -4.267082) " points="8.32645425 1.81174966 8.32645425 6.72241416 3.41578975 6.72241416"/>
        <path d="M0.475809537,11.3602979 L0.475809537,7.50978539" id="Path-2"/>
        <path d="M0.475809537,7.50978539 C0.475809537,5.71888971 1.92761734,4.26708191 3.71851302,4.26708191 C3.71851302,4.26708191 9.34439546,4.26708191 9.34348617,4.26708191" id="Oval"/>
      </g>
    </g>
  </g>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



/** WEBPACK FOOTER **
 ** ./assets/icons/external.svg
 **/